// extracted by mini-css-extract-plugin
export default {"header":"styles_header__O18jo","logo":"styles_logo__jKFih","support":"styles_support__6GEto"};